import { SideBar } from './navigation/SideBar';
import AppRouter from './router/AppRouter';
import React from 'react';
import { OnboardingWizard } from './onboarding/containers/OnboardingWizard';
import { useFetchedOnboardingProgress } from './onboarding/hooks/useFetchedOnboardingProgress';
import { ONBOARDING_STATE_IN_PROGRESS, ONBOARDING_STATE_NOT_STARTED } from './user/userApi';
import useAuth from './auth/authContext';
import { SplashScreen } from './commons/SplashScreen';

export const AppRoot = () => {
  const {
    state: { user },
  } = useAuth();

  const {
    query: { data: onboardingProgress },
    queryStatusComponent,
  } = useFetchedOnboardingProgress();

  const isOnboardingRunning =
    onboardingProgress &&
    (onboardingProgress.state === ONBOARDING_STATE_NOT_STARTED ||
      onboardingProgress.state === ONBOARDING_STATE_IN_PROGRESS);

  if (user && !onboardingProgress) return <SplashScreen>{queryStatusComponent}</SplashScreen>;

  return (
    <>
      {user && isOnboardingRunning ? (
        <OnboardingWizard onboardingProgress={onboardingProgress} />
      ) : (
        <>
          <SideBar />
          <AppRouter />
        </>
      )}
    </>
  );
};
